import PartnerTemplate from '../components/marketing/PartnerTemplate';

/* Narmi × Clarid — technology partner (dual lockup, "Clarid inside your platform"). */
export default function NarmiPartnerPage() {
  return (
    <PartnerTemplate
      docTitle="Narmi + Clarid — AI-Native Compliance for AI-Native Banking"
      lockup="dual"
      partnerName="Narmi"
      partnerLogo="/narmi-logo.png"
      eyebrow="§ PARTNERSHIP · NARMI × CLARID"
      headline={<>AI-native compliance for <span className="frame-quote">AI-native banking.</span></>}
      lead="Narmi runs the digital front door for community banks and credit unions. Clarid runs the compliance layer behind it — so the institutions on your platform stay examiner-ready as they grow, without bolting on another vendor."
      thesisKicker="§ 01 · WHY THIS PARTNERSHIP"
      thesisHeadline="What it unlocks for the banks on your platform."
      thesis={[
        {
          well: '01',
          title: 'Compliance keeps pace with growth',
          body: "As an institution scales account opening and lending on Narmi, Clarid scales the marketing, policy, and fair-lending checks alongside it — no compliance bottleneck on the platform's growth.",
        },
        {
          well: '02',
          title: 'One connected program, not another silo',
          body: 'A finding in one module surfaces an insight in another and rolls into one examiner-ready package. Your banks get connected compliance, not a sixth disconnected tool to reconcile.',
        },
        {
          well: '03',
          title: 'Examiner-ready by default',
          body: 'Every check is timestamped and SHA-256-verified. The institutions you serve walk into exams with the evidence already assembled — a quieter exam season for them, a stickier platform for you.',
        },
      ]}
      bringsHeadline="Compliance depth, sized for a platform."
      depth={[
        { label: 'Marketing', txt: 'Automated marketing-compliance review — the disclosures, fair-lending language, and UDAAP checks every campaign needs.' },
        { label: 'Policy', txt: 'Compliance program & policy management, kept current against regulatory change.' },
        { label: <>Lending <span style={{ color: 'var(--ochre)' }}>· roadmap</span></>, txt: 'Lending box-checks — HMDA and fair-lending screening on originations flowing through the platform.' },
      ]}
      proofs={[
        { stat: '170+ HMDA edit checks', desc: 'Full LAR validation against the current edit-check set.' },
        { stat: 'FRB Fair Lending Tool — to the decimal', desc: "Clarid reproduces the Federal Reserve's fair-lending methodology exactly, not an approximation." },
        { stat: 'Deterministic · multi-provider', desc: "Circuit-breaker fallback across providers — it kept running through Anthropic's largest-ever outage. SHA-256-verified exam packages." },
      ]}
      integration={{
        kicker: '§ 03 · HOW IT WORKS TOGETHER',
        headline: 'Clarid inside your platform.',
        lead: "Clarid runs as the embedded compliance layer — activity on Narmi flows through Clarid's checks, and findings roll into the institution's connected compliance record.",
        barLabel: 'narmi.platform · compliance layer = clarid',
        flow: [
          { name: 'Narmi platform', sub: 'Account opening · digital banking · lending' },
          { name: 'Clarid · compliance layer', sub: 'Marketing & policy checks · fair-lending screening · audit trail', clarid: true },
          { name: 'Examiner-ready', sub: 'Connected record · one-click package' },
        ],
        tags: [
          { label: '✓ Marketing review · shipped', kind: 'shipped' },
          { label: '✓ Policy management · shipped', kind: 'shipped' },
          { label: '◇ Embedded lending box-checks · roadmap', kind: 'roadmap' },
        ],
        note: '▢ integration shape — illustrative; final technical mechanics scoped with Narmi. Roadmap items marked as roadmap.',
      }}
      contact={{ name: 'Bobby Sloan', title: 'Founder & CEO, Clarid', email: 'bobby@clarid.ai' }}
    />
  );
}
